module.exports = __webpack_public_path__ + "static/media/infinity.91a1f0e1.svg";